import React from 'react';
import { Helmet } from 'react-helmet';

// Visible FAQ + matching FAQPage JSON-LD from one array, so the structured
// data can never list questions that aren't on the page (Google requires
// FAQ markup to match visible content).
//
// faqs: [{ q, a }] — a is plain text. Pass `text` too if `a` is JSX.
function FaqSection({ faqs, title = "Frequently asked questions", className = "" }) {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map((f) => ({
            "@type": "Question",
            "name": f.q,
            "acceptedAnswer": { "@type": "Answer", "text": f.text || f.a },
        })),
    };

    return (
        <section className={`mt-10 ${className}`}>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            </Helmet>
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">{title}</h2>
            <div className="space-y-4">
                {faqs.map((f) => (
                    <div key={f.q} className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg">
                        <h3 className="font-bold text-gray-800 dark:text-gray-100 mb-1">{f.q}</h3>
                        <p className="text-gray-600 dark:text-gray-300">{f.a}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default FaqSection;
